import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import { Switch } from 'react-router-dom/cjs/react-router-dom.min';
import PerformancePage from '../components/Pages/Performance';
import CompaniesPage from '../components/Pages/Companies';
import CompanyPage from '../components/Pages/Company';
import HomePage from '../components/Pages/Home/HomePage';
import ForgotPasswordPage from '../components/Pages/ForgotPassword';
import LogoutPage from '../components/Pages/Logout';
import OrderPage from '../components/Pages/Order';
import OrderDetailPage from '../components/Pages/OrderDetail/OrderDetail';
import NewOrdersPage from '../components/Pages/OrdersNew';
import ResetPasswordPage from '../components/Pages/ResetPassword';
import CreateAccountPage from '../components/Pages/CreateAcount';
import RidersPage from '../components/Pages/Riders';
import RoutePlanAddOrdersPage from '../components/Pages/RoutePlanAddOrders';
import RoutePlanAddRidersPage from '../components/Pages/RoutePlanAddRiders';
import RoutePlanDetailPage from '../components/Pages/RoutePlanDetail';
import RoutesPage from '../components/Pages/Routes';
import SettingsPage from '../components/Pages/Settings';
import CarriersPage from '../components/Pages/Carriers/Carriers';
import SignInPage from '../components/Pages/SignIn';
import UsersPage from '../components/Pages/Users';
import VehiclesPage from '../components/Pages/Vehicles';
import { ROLES } from '../constants/index';
import { PrivateRoute } from '../modules/auth/containers';
import AppError from './AppError';
import AppMessage from './AppMessage';
import IssuesPage from '../components/Pages/Issues';
import ServiceLevelPage from '../components/Pages/ServiceLevel';
import SustainabilityPage from '../components/Pages/Sustainability';
import CustomerJourney from '../components/Pages/CustomerJourney/CustomerJourney';
import { ControlTower } from '../components/Pages/ControlTower/ControlTower';
import ClaimsPage from '../components/Pages/Claims/Claims';
import CarrierPage from '../components/Pages/Carriers/CarrierPage';

const App = () => {
  const globalLoading = useSelector((state) => state.common.globalLoading);

  const settingTabs = [
    // 'user-profile',
    // 'integrations',
    // 'track-trace',
    // 'delivery-methods',
    // 'labels',
    // 'carriers',
    // 'delivery-areas',
    'carrier-rules',
    // 'api',
    // 'sparqle-labs',
  ];
  return (
    <Spin spinning={globalLoading} wrapperClassName="wrap-spin">
      <AppError />
      <AppMessage />
      <Switch>
        <Route exact path="/login" component={SignInPage} />
        <Route exact path="/logout" component={LogoutPage} />
        <Route exact path="/forgot-password" component={ForgotPasswordPage} />
        <Route exact path="/reset-password" component={ResetPasswordPage} />
        <Route exact path="/create-account" component={CreateAccountPage} />
        <PrivateRoute
          exact
          path="/home"
          component={HomePage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute exact path="/companies" component={CompaniesPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/companies/new" component={CompanyPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/companies/:id" component={CompanyPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/control-tower" component={ControlTower} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute
          exact
          path="/issues"
          component={IssuesPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute
          exact
          path="/claims"
          component={ClaimsPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute
          exact
          path="/claims/:id"
          component={ClaimsPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute
          exact
          path="/orders/new"
          component={OrderPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER]}
        />
        <PrivateRoute exact path="/riders" component={RidersPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/vehicles" component={VehiclesPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/users" component={UsersPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/carriers" component={CarriersPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute exact path="/carriers/:id" component={CarrierPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute
          exact
          path="/customer-journey"
          component={CustomerJourney}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER]}
        />
        <PrivateRoute
          exact
          path="/orders"
          component={NewOrdersPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute
          exact
          path="/orders/:id"
          component={OrderDetailPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        <PrivateRoute
          exact
          path="/orders/:id/issue/:issueId"
          component={OrderDetailPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER]}
        />
        <PrivateRoute exact path="/routes" component={RoutesPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute
          exact
          path="/performance"
          component={PerformancePage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER]} //, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER]}
        />
        <PrivateRoute exact path="/service-level" component={ServiceLevelPage} allowedRoles={[ROLES.CARRIER_USER]} />
        <PrivateRoute
          exact
          path="/sustainability"
          component={SustainabilityPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER]}
        />
        <PrivateRoute exact path="/routes/:id" component={RoutePlanDetailPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute
          exact
          path="/routes/:id/add-riders"
          component={RoutePlanAddRidersPage}
          allowedRoles={[ROLES.ADMIN]}
        />
        <PrivateRoute
          exact
          path="/routes/:id/add-orders"
          component={RoutePlanAddOrdersPage}
          allowedRoles={[ROLES.ADMIN]}
        />
        <PrivateRoute exact path="/routes/:id/:type" component={RoutePlanDetailPage} allowedRoles={[ROLES.ADMIN]} />
        <PrivateRoute
          exact
          path="/settings"
          component={SettingsPage}
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER, ROLES.CARRIER_USER]}
        />
        {settingTabs.map((t) => (
          <PrivateRoute
            exact
            key={t}
            path={`/settings/${t}`}
            component={SettingsPage}
            activeTab={t}
            allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER]}
          />
        ))}
        {/* <PrivateRoute
          exact
          path="/settings/carrier-rules"
          component={SettingsPage}
          activeTab="carrier-rules"
          allowedRoles={[ROLES.ADMIN, ROLES.COMPANY_OWNER, ROLES.LOCATION_USER]}
        /> */}

        <Route path="/*" render={(props) => <PageNotFound {...props} />} />
      </Switch>
    </Spin>
  );
};

function PageNotFound() {
  return <Redirect to={`/home`} />;
}

export default App;
